// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderRightOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderRightOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderRightOutlined = function BorderRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderRightOutlinedSvg
  }));
};

BorderRightOutlined.displayName = 'BorderRightOutlined';
export default React.forwardRef(BorderRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BorderRightOutlined.js
// module id = 667
// module chunks = 0